<template>
  <div class="w-full bg-white height-100">
    <!-- <el-dialog class="ne-oppop" width="70%" :visible.sync="popupnew" center>
      <templateSelect />
    </el-dialog> -->
    <el-dialog :visible.sync="show" width="30%" center class="ishidePopup">
      <div class="flex justify-center items-center">
        <div class="">
          <div class="mt-2">
            <p class="text-lg font-semibold mb-0 text-black">Email ID</p>
            <el-input
              placeholder="Enter the Email ID"
              maxlength="50"
              class="mt-1"
              v-model="emailConfig"
            ></el-input>
          </div>
          <div class="mt-2">
            <p class="fsize12 col-4f">
              Our representative will call you for further setups in next 24-48
              hours. For support, contact
              <span class="text-primary font-semibold"
                >support@brained.app</span
              >
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              @click="CreateEmailConfig()"
              class="bg-gtr rounded-full border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Submit
            </vs-button>
            <vs-button
              @click="show = false"
              type="secondary"
              class="bg-secondary rounded-full border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowNewSegment" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="centerDialogVisiblert"
      width="30%"
      center
      class="ishidePopup"
    >
      <div class="flex justify-center items-center">
        <div class="">
          <div class="mt-2">
            <p class="text-lg font-semibold mb-0 text-black">Enter Name</p>
            <el-input
              placeholder="Please input"
              maxlength="50"
              class="mt-1"
              v-model="input"
            ></el-input>
          </div>
          <div class="mt-2">
            <p class="fsize12 col-4f">
              Our representative will call you for further setups in next 24-48
              hours
            </p>
          </div>
          <div class="flex gap-4 justify-center mt-4 items-center">
            <vs-button
              type="success"
              class="border-0 bg-success rounded-full text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Submit
            </vs-button>
            <vs-button
              @click="isShowCampaignPopup = true"
              class="bgtyr border-0 rounded-4px text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="handleCreateSegment"
      width="50%"
      class="ishidePopup"
      center
    >
      <div>
        <div>
          <el-radio class="lbl-plrem" v-model="isShowSegment" label="1"
            >Send Individually</el-radio
          >
          <el-radio class="lbl-plrem" v-model="isShowSegment" label="2"
            >Send by Segment</el-radio
          >
        </div>
        <div class="relative mt-6">
          <el-input
            placeholder="Enter Search..."
            maxlength="50"
            class="rounded-xl"
            v-model="searchInput"
          />
        </div>

        <div class="mt-8">
          <div v-if="isShowSegment === '1'">
            <SendIndividuallyTable
              :search="searchInput"
              @handleCreateSegmentPopup="handleCreateSegmentPopup"
              @segments="multipleUserSelected"
            />
          </div>

          <div v-if="isShowSegment === '2'">
            <SendBySegment
              :search="searchInput"
              @segments="multipleSegmentSelected"
              @handleCreateSegmentPopup="handleCreateSegmentPopup"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      class="ishidePopup"
    >
      <div class="flex justify-center items-center">
        <div>
          <div class="flex justify-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="w-32 h-32"
            />
          </div>
          <div class="text-center mt-3">
            <h4 class="font-semibold text-dark text-2xl">
              You Need more Email Credits
            </h4>
            <p class="fsize12 col-4f">
              The Campaign is set to target
              <span class="text-primary pt-2 font-semibold">
                {{ uniqueUserData.length }}</span
              >
              audience. need
              <span class="text-primary font-semibold">
                {{
                  Math.abs(
                    this.myAddOns.length &&
                      this.myAddOns[1].addOnId &&
                      myAddOns[1].addOnId.quantity
                      ? myAddOns[1].addOnId.quantity - uniqueUserData.length
                      : ""
                  )
                }}</span
              >
              more email credits to run this Campaign
            </p>
          </div>
          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              type="success"
              @click="handleClick('Add-ons')"
              class="bg-success rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              By more Email credits
            </vs-button>
            <!-- <vs-button
              type="primary"
              @click="isShowCampaignPopup = true"
              class="bg-primary rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              Edit Target audience
            </vs-button> -->
            <vs-button
              type="primary"
              @click="centerDialogVisible = false"
              class="bg-primary rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              Edit Target audience
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="isShowCampaignPopup"
      custom-class="ishidePopup"
      width="30%"
      center
    >
      <div class="">
        <div class="block">
          <div>
            <span class="demonstration text-dark font-semibold"
              >Pick a Date & Time</span
            >
          </div>
          <el-date-picker
            v-model="datepick"
            type="date"
            placeholder="Pick a date"
            class="mt-3 w-full"
          >
          </el-date-picker>
        </div>
        <p class="text-8f8f8f fsize12 mt-2">
          You can alwys change the schedule later by visting your planner before
          the event goes live.
        </p>

        <el-divider class="text-primary font-semibold">OR</el-divider>
        <div>
          <div class="flex items-center">
            <input type="checkbox" class="cust-check" />
            <p class="pl-2 mb-0 text-dark font-semibold">Start it Instantly</p>
          </div>
          <p class="text-8f8f8f fsize12 mt-1">
            Link a specific page or a website you'd like to inclide in your
            campaign
          </p>
        </div>

        <div class="flex gap-4 justify-center mt-6 items-center">
          <vs-button
            type="success"
            class="bg-success w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Confirm Campaign
          </vs-button>
          <vs-button
            type="secondary"
            class="bg-secondary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create a Email Campaign
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white px-6 py-8 menucontrol-scroll fixed-top">
      <div class="flex items-start w-full">
        <div class="w-2/5 pr-20">
          <div
            class="bg-3a3a3a p-8 rounded-10px"
            v-if="selectedTemplate === ''"
          >
            <div class="rounded-6px bg-f4f5f6 h-32"></div>

            <div class="mt-4">
              <p class="text-white wordf">Hi,</p>

              <p class="text-white wordf">
                Make your emails pop with an attractive banner. Make your emails
                pop with an attractive banner.
              </p>

              <p class="text-white wordf py-4">
                Make your emails pop with an attractive banner.<span
                  class="text-primary ml-1"
                  >https://brained.app</span
                >
              </p>

              <p class="text-white mb-1">Thankyou,</p>
              <p class="text-white">Business Name</p>
            </div>

            <div class="grid grid-cols-3 gap-3 mt-2">
              <div class="rounded-6px bg-f4f5f6 h-95px"></div>
              <div class="rounded-6px bg-f4f5f6 h-95px"></div>
              <div class="rounded-6px bg-f4f5f6 h-95px"></div>
            </div>

            <div class="mt-12">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                alt="instagram"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                alt="youtube"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                alt="facebook"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                alt="twitter"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                alt="whatsapp"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                alt="linkedin"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="bg-3a3a3a p-8 rounded-10px"
            v-if="selectedTemplate.templateId === 0"
          >
            <div class="rounded-6px bg-f4f5f6 h-32">
              <img
                :src="
                  selectedTemplate
                    ? this.$imageURL + '/' + selectedTemplate.image1
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-10px object-cover h-full"
                alt="image1"
              />
            </div>

            <div class="mt-4">
              <!-- <p class="text-white" v-html="body1"></p> -->

              <p class="text-white" v-html="selectedTemplate.body1"></p>
              <p class="text-white mb-1">Thankyou,</p>
              <p class="text-white">{{ this.selectedProject.displayName }}</p>
            </div>

            <div class="mt-10">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                alt="instagram"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                alt="youtube"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                alt="facebook"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                alt="twitter"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                alt="whatsapp"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                alt="linkedin"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="bg-3a3a3a p-8 rounded-10px"
            v-if="selectedTemplate.templateId === 2"
          >
            <div class="rounded-6px bg-f4f5f6 h-32">
              <img
                :src="
                  selectedTemplate
                    ? this.$imageURL + '/' + selectedTemplate.image1
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image1"
              />
            </div>

            <div class="mt-6">
              <div class="flex">
                <div class="w-1/4">
                  <div class="rounded-6px bg-f4f5f6 h-24">
                    <img
                      :src="
                        selectedTemplate
                          ? this.$imageURL + '/' + selectedTemplate.image2
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image2"
                    />
                  </div>
                </div>

                <div class="w-3/4 pl-4">
                  <p
                    class="text-white fsize12"
                    v-html="selectedTarget.body1"
                  ></p>
                  <!-- <p class="text-white fsize12" v-html="body1"></p> -->
                </div>
              </div>

              <div class="flex mt-6">
                <div class="w-1/4">
                  <div class="rounded-6px bg-f4f5f6 h-24">
                    <img
                      :src="
                        selectedTemplate
                          ? this.$imageURL + '/' + selectedTemplate.image3
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="w-full rounded-md object-cover h-full"
                      alt="image3"
                    />
                  </div>
                </div>

                <div class="w-3/4 pl-4">
                  <p
                    class="text-white fsize12"
                    v-html="selectedTarget.body2"
                  ></p>
                  <!-- <p class="text-white fsize12" v-html="body2"></p> -->
                </div>
              </div>
              <div class="mt-6">
                <p class="text-white mb-1">Thankyou,</p>
                <p class="text-white">
                  {{ this.selectedProject.displayName }}
                </p>
              </div>
            </div>

            <div class="mt-10">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                alt="instagram"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                alt="youtube"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                alt="facebook"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                alt="twitter"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                alt="whatsapp"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                alt="linkedin"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="bg-3a3a3a p-8 rounded-10px"
            v-if="selectedTemplate.templateId === 3"
          >
            <div class="rounded-6px bg-f4f5f6 h-32">
              <img
                :src="
                  selectedTemplate
                    ? this.$imageURL + '/' + selectedTemplate.image1
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image1"
              />
            </div>
            <div class="grid grid-cols-3 gap-3 mt-4">
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image2
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image2"
                />
              </div>
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image3
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image3"
                />
              </div>
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image4
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image4"
                />
              </div>
            </div>
            <div class="mt-4">
              <!-- <p class="text-white" v-html="body1"></p> -->
              <p class="text-white" v-html="selectedTemplate.body1"></p>

              <p class="text-white mb-1">Thankyou,</p>
              <p class="text-white">{{ this.selectedProject.displayName }}</p>
            </div>

            <div class="mt-10">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                alt="instagram"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                alt="youtube"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                alt="facebook"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                alt="twitter"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                alt="whatsapp"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                alt="linkedin"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="bg-3a3a3a p-8 rounded-10px"
            v-if="selectedTemplate.templateId === 1"
          >
            <div class="rounded-6px bg-f4f5f6 h-32">
              <img
                :src="
                  selectedTemplate
                    ? this.$imageURL + '/' + selectedTemplate.image1
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image1"
              />
            </div>

            <div class="mt-4">
              <p class="text-white" v-html="selectedTemplate.body1"></p>

              <p class="text-white mb-1">Thankyou,</p>
              <p class="text-white">{{ this.selectedProject.displayName }}</p>
            </div>

            <div class="grid grid-cols-3 gap-3 mt-2">
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image2
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image2"
                />
              </div>
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image3
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image3"
                />
              </div>
              <div class="rounded-6px bg-f4f5f6 h-95px">
                <img
                  :src="
                    selectedTemplate
                      ? this.$imageURL + '/' + selectedTemplate.image4
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image4"
                />
              </div>
            </div>

            <div class="mt-12">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                alt="instagram"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                alt="youtube"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                alt="facebook"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />

              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                alt="twitter"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                alt="whatsapp"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                alt="linkedin"
                class="w-4 mr-4 h-4 object-contain cursor-pointer"
              />
            </div>
          </div>
        </div>
        <div class="w-3/5 bg-white lg:pb-32 relative">
          <div class="grid grid-cols-2 gap-8">
            <div>
              <div class="">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Give a title to this Campaign
                </h6>

                <el-input
                  placeholder="Please Add Campaign Title"
                  class="mt-3 w-full"
                  maxlength="50"
                  v-model="title"
                ></el-input>
                <p
                  v-if="submitted == true && title == ''"
                  class="fsize12 text-danger"
                >
                  {{
                    title === "" || title[0].trim() !== ""
                      ? "This Field is required"
                      : ""
                  }}
                </p>
              </div>
              <div class="mt-6">
                <h6 class="col-4f text-lg mb-0">Select Sender ID</h6>

                <el-select
                  v-model="selectedSenderId"
                  placeholder="Select Sender ID"
                  class="w-full mt-2"
                >
                  <!-- <el-option
                    @click="show = true"
                    label="Create Sender Id"
                    value="Create Sender Id"
                  >
                  </el-option> -->
                  <el-option
                    v-for="item in senderIdOptions"
                    :key="item._id"
                    :label="item.email"
                    :value="item.email"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ selectedSenderId === "" ? "This Field is required" : "" }}
                </p>
                <div class="mt-4 w-full">
                  <p
                    class="w-full text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                    @click="show = true"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />Create
                    New SenderID
                  </p>
                </div>
              </div>
              <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Template
                </h6>

                <el-select
                  filterable
                  v-model="selectedTemplate"
                  placeholder="Select Template"
                  class="w-full mt-2"
                  value-key="_id"
                  :disabled="!selectedSenderId"
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item._id"
                    :label="item.templateName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ selectedTemplate === "" ? "This Field is required" : "" }}
                </p>
                <el-divider>or</el-divider>
                <!-- <p
                  @click="popupnew = true"
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                > -->
                <p
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                  @click="handleSend('marcom-Templateselect')"
                >
                  <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />Create
                  New Template
                </p>
              </div>
            </div>
            <div>
              <!-- <div class="">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Target Segment
                </h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Select the target audience segment for this Campaign
                </p>
                <el-select
                  v-model="value"
                  placeholder="Select"
                  multiple
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div> -->
              <!-- <div class="mt-6">
                <div
                  class="p-3 rounded-md bg-light-primary flex items-center justify-center gap-2"
                >
                  <div class="flex items-center gap-2">
                    <feather-icon icon="PlusIcon" class="text-primary" />
                    <p class="text-primary fsize14 mb-0 font-semibold">
                      Create new Segment
                    </p>
                  </div>
                </div>
              </div> -->
              <div>
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Target Segment
                </h6>

                <div
                  class="flex flex-wrap border mt-4 p-3"
                  @click="handleCreateSegment = true"
                >
                  <el-tag
                    v-show="selectedTarget.length !== 0"
                    v-for="item in selectedTarget"
                    :key="item.value"
                    :label="item.label"
                    :value="item.name"
                    closable
                    @close="handleClose(item._id)"
                    class="mb-2 mr-2 rounded-4px bg-primary text-white fsize10"
                    >{{ item.name }}</el-tag
                  >

                  <p
                    v-show="selectedTarget.length === 0"
                    class="text-8f8f8f fsize12 mb-0"
                  >
                    Select Target Segment
                  </p>
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    uniqueUserData.length === 0 && selectedTarget.length === 0
                      ? "This Field is required"
                      : ""
                  }}
                </p>
              </div>
              <el-divider>or</el-divider>
              <div class="mt-6">
                <div
                  @click="isShowNewSegment = true"
                  class="p-3 rounded-md cursor-pointer bg-light-primary flex items-center justify-center gap-2 rounded-4px"
                >
                  <div class="flex items-center gap-2">
                    <feather-icon
                      icon="PlusIcon"
                      svgClasses="w-5 h-5"
                      class="text-primary"
                    />
                    <p class="text-primary font-semibold fsize12 mb-0">
                      Create New Segment
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex justify-between w-full mt-2">
                <div class="flex gap-2 items-center">
                  <p class="col-4f fsize12 font-medium">TG Size:</p>
                  <p class="text-primary fsize12 font-semibold">
                    {{ this.uniqueUserData.length }}
                  </p>
                </div>
                <div class="flex gap-2 items-center">
                  <p class="col-4f fsize12 font-medium">Email Credits:</p>
                  <p class="text-primary fsize12 font-semibold">
                    {{
                      this.myAddonsData.quantity
                        ? this.myAddonsData.quantity
                        : 0
                    }}
                  </p>
                </div>
              </div>

              <div
                class="mt-6 bg-f4f5f6 p-4 rounded-6px"
                v-if="this.myAddonsData.quantity <= 100"
              >
                <h3 class="font-semibold col-4f text-xl">Resources</h3>
                <div class="flex items-center mt-4 w-full">
                  <div class="flex gap-2 items-center w-full">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/sms.svg"
                      class="object-contain"
                      alt="banh"
                    />

                    <div class="mt-2 pl-4">
                      <h2 class="font-semibold mb-0 col-4f text-lg">
                        x 1000 Email Credits
                      </h2>
                      <p class="fsize12 mt-0 col-4f">You have Email Credits</p>
                    </div>
                  </div>
                </div>

                <div class="w-full mt-4">
                  <vs-button
                    color="success"
                    @click="handleClick('Add-ons')"
                    class="w-full bg-success border-0 text-white font-normal fsize14"
                  >
                    Buy More
                  </vs-button>
                </div>
              </div>
              <!-- <div class="mt-6">
                <h6 class="col-4f text-2xl mb-0">Pick a Template</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Select a layout for your email
                </p>
                <div class="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <img
                      src="@/assets/images/frag.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag2.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag3.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag4.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="absolute bottom-0 right-0">
            <!-- <div @click="centerDialogVisible = true" class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
              />
            </div> -->
            <!-- <div
              class="bg-primary w-24 h-24 rounded-full cursor-pointer"
              @click="centerDialogVisible = true"
            > -->
            <div class="bg-primary w-24 h-24 rounded-full cursor-pointer">
              <div
                class="flex justify-center items-center w-24 h-24"
                @click="handleSubmit('marcom-Whatsappcampaign-complete')"
              >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses="w-10 h-10"
                  class="text-white flex"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";
import { mapState } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import axios from "axios";
import AddSegmentTable from "./components/AddSegmentTable";
import SendBySegment from "./components/SendBySegment";
import SendIndividuallyTable from "./components/SendIndividuallyTable.vue";
import templateSelect from "../templateSelect/templateSelect.vue";

export default {
  data() {
    return {
      emailConfig: "",
      centerDialogVisible: false,
      centerDialogVisiblert: false,
      textarea2: "",
      input: "",
      search: "",
      datepick: "",
      isShowNewSegment: false,
      popupnew: false,
      isShowCampaignPopup: false,
      uniqueUserData: [],
      handleCreateSegment: false,
      isShowSegment: "1",
      segmentData: [],
      selectedTarget: [],
      // multipleUserSelected: [],
      // multipleSegmentSelected: [],
      dataName: "",
      tag: "",
      title: "",
      selectedTemplate: "",
      templateOptions: [],
      selectedSenderId: "",
      senderIdOptions: [],
      show: false,
      mobile: "",
      submitted: false,
      myAddonsData: "",
      searchInput: "",
    };
  },

  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("email", ["getAllEmailTemplate", "getEmailConfig"]),
    ...mapState("admin", ["myAddOns"]),
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("marcom", ["taskListUsers"]),
  },
  components: {
    SendBySegment,
    SendIndividuallyTable,
    AddSegmentTable,
    VueEditor,
    templateSelect,
  },
  methods: {
    handleSend(name) {
      this.$router.push({ name: name });
    },
    async CreateEmailConfig() {
      try {
        let payload = {
          email: this.emailConfig,
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          user: this.taskListUsers.PM[0]._id,
        };

        let URL =
          this.selectedProject.projectName == "nhrdn"
            ? process.env.VUE_APP_BASE_API + "/marcom/email/createEmailConfig"
            : `https://cera-api.aiab.in/api/marcom/email/createEmailConfig`;

        let { data } = await axios.post(URL, payload, {
          headers: {
            Accept: "application/json",
          },
        });

        if (data.code == 200 && !data.data.code) {
          this.show = false;
          this.$swal({
            title: "Success!",
            text: `Email Config Initiated Successfully`,
            icon: "success",
            timer: 2000,
            buttons: false,
          });
        } else {
          this.$swal({
            title: "Warning!",
            text: `Email Already exists`,
            icon: "warning",
            timer: 5000,
            buttons: false,
          });
        }

        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async createSmsConfig() {
      await this.$store.dispatch("smsCampaign/createSmsConfig", {
        mobile: this.mobile,
        projectId: this.selectedProject._id,
      });
    },
    downloadPdf() {
      this.createSmsConfig();
      window.open(`${this.$imageURL}/brained/admin/sms_setup/SMS%20Setup.zip`);
      this.show = false;
    },
    getUniqueUserData(segmentData) {
      let audienceData = [];
      segmentData.forEach((data) => {
        data.audienceId.forEach((audience) => {
          const { _id, email } = audience;
          audienceData.push({ _id, email });
        });
      });

      let filtered = audienceData.filter(function ({ _id, email }) {
        let key = `${_id}${email}`;
        return !this.has(key) && this.add(key);
      }, new Set());

      // console.log(filtered);
      this.uniqueUserData = filtered;
    },
    handleClose(id) {
      this.selectedTarget.splice(
        this.selectedTarget.findIndex((x) => x._id === id),
        1
      );
      if (this.dataName === "segment") {
        this.getUniqueUserData(this.selectedTarget);
      } else {
        this.uniqueUserData = this.selectedTarget.map((user) => {
          const { _id, email } = user;
          return { _id, email };
        });
      }
    },
    multipleSegmentSelected(val) {
      // console.log(val);
      this.selectedTarget = val;
      this.dataName = "segment";
      this.getUniqueUserData(this.selectedTarget);
    },
    multipleUserSelected(val) {
      // console.log(val);
      this.selectedTarget = val;
      this.dataName = "user";
      this.uniqueUserData = this.selectedTarget.map((user) => {
        const { _id, email } = user;
        return { _id, email };
      });
    },
    handleAddNewSegment() {
      this.isShowNewSegment = false;
    },
    async getAllmyAddons() {
      let emailAddOns = {};
      for (let i of this.myAddOns) {
        if (i.addOnId.flag == "PT_EMAILS") {
          emailAddOns = i;
        }
      }
      this.myAddonsData = emailAddOns;
    },
    async handleSubmit(name) {
      this.submitted = true;
      if (this.myAddonsData.quantity < this.uniqueUserData.length) {
        this.centerDialogVisible = true;
      } else {
        if (
          this.myAddOns.length &&
          this.myAddOns[1].addOnId &&
          this.myAddOns[1].addOnId.quantity
            ? this.myAddOns[1].addOnId.quantity - this.uniqueUserData.length < 0
            : ""
        ) {
          this.centerDialogVisible = true;
          return;
        }
        if (
          this.title !== "" &&
          this.selectedTemplate !== "" &&
          this.selectedSenderId !== "" &&
          // this.uniqueUserData !== ""
          this.uniqueUserData.length != 0
        ) {
          this.$swal
            .fire({
              title: "Alert",
              text: `Are you sure you want to proceed with the selected data, Selected Template will be sent to ${
                this.uniqueUserData.length == 1
                  ? "1 user"
                  : this.uniqueUserData.length + " " + "users"
              }`,
              icon: "warning",
              confirmButtonText: "Yes, Continue",
              cancelButtonText: "Cancel",
              showCancelButton: true,
              confirmButtonColor: "#EA4Dff",
              cancelButtonColor: "  #6e7881",
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                let payload = {
                  title: this.title,
                  template: this.selectedTemplate,
                  senderId: this.selectedSenderId,
                  targetData: this.uniqueUserData,
                  instagram: this.brandProfile.contactDetails.instagram,
                  whatsapp: this.brandProfile.contactDetails.whatsapp,
                  facebook: this.brandProfile.contactDetails.facebook,
                  pinterest: this.brandProfile.contactDetails.pintrest,
                  linkedin: this.brandProfile.contactDetails.linkedin,
                  // targetData: datas,
                };

                console.log(payload);

                try {
                  const data = await this.$store.dispatch(
                    "email/createEmailCampaign",
                    payload
                  );

                  if (data.code == 200 && !data.data.code) {
                    this.$swal({
                      title: "Email Campaign Created Successfully",
                      // text: message,
                      icon: "success",
                      confirmButtonColor: "#830c81",
                      confirmButtonText: "OK",
                    });
                    this.submitted = false;
                    this.title = "";
                    this.selectedSenderId = "";
                    this.selectedTarget = [];
                    this.uniqueUserData = [];
                    this.selectedTemplate = "";
                  } else {
                    this.$swal({
                      title: "Campaign Name Already Exists",
                      // text: message,
                      icon: "warning",
                      confirmButtonColor: "#830c81",
                      confirmButtonText: "OK",
                    });
                  }
                } catch (error) {
                  console.log(error);
                }
              }
            });

          console.log(payload);
        }
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async getAllSegments() {
      try {
        let data = await this.$store.dispatch("segment/getAllSegment");
        this.segmentData = data.data;
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    segments(segments) {
      this.segmentData = segments;
      this.handleCreateSegmentPopup();
    },
    handleCreateSegmentPopup() {
      this.handleCreateSegment = false;
    },

    async getEmailTemplatesHandler() {
      let payload = {
        status: "approved",
      };
      try {
        await this.$store.dispatch("email/getAllEmailTemplate", payload);
        this.templateOptions = this.getAllEmailTemplate;
        // console.log(this.templateOptions);
      } catch (error) {
        console.log(error);
      }
    },
    async getEmailConfigHandler() {
      let payload = {
        projectId: this.selectedProject._id,
        // communityName: this.selectedProject.projectName,
      };
      try {
        await this.$store.dispatch("email/getEmailConfig", payload);
        this.senderIdOptions = this.getEmailConfig;
        // console.log(this.senderIdOptions);
      } catch (error) {
        console.log(error);
      }
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.title = this.title ? this.title.trimStart() : "";
      });
    },
  },
  watch: {
    selectedSenderId(val) {
      if (val == "Create Sender Id") {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    title() {
      this.whitespaceRemove();
    },
  },
  async mounted() {
    this.getAllmyAddons();
    this.getEmailTemplatesHandler();
    this.getEmailConfigHandler();
    this.getAllSegments();
  },
};
</script>
